import {useState} from 'react'

import {
    Grid,
    Stack,
    Button,
    Avatar,
    List,
    IconButton,
    ListItem,
    ListItemButton,
    ListItemAvatar,
    ListItemText,
    Dialog, DialogContent, Toolbar, Typography,
} from '@mui/material'
import ItemsAutoComplete from "../_customs/ItemsAutoComplete";

import {Delete, Close} from "@mui/icons-material";

import {PDFViewer, Page, View, Document, StyleSheet, Text, Image} from '@react-pdf/renderer';
import useToggle from "../../shared/functions/useToggle";

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#ffffff'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    }
});

export default function ItemPDF() {
    const {open, handleOpen, handleClose} = useToggle()
    const [selected, setSelected] = useState([])

    const handlePick = (collection = []) => {
        setSelected(state => [...state, ...collection])
    }

    const handleRemove = (id) => {
        setSelected(state => state?.filter(one => one?.id !== id))
    }

    const handlePrint = () => {
        handleOpen()
    }

    return (
        <Stack justifyContent={'center'} spacing={2}>
            <ItemPicker onPick={handlePick}/>

            <List>

                {
                    selected?.map(item => (
                        <ListItem key={item?.id}>
                            <ListItemButton>
                                <ListItemAvatar>
                                    <Avatar src={item?.imageUrl}/>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={item?.name}
                                    secondary={`${item?.barCode} | ${item?.internalId} `}
                                />
                                <IconButton onClick={() => handleRemove(item?.id)}>
                                    <Delete/>
                                </IconButton>
                            </ListItemButton>
                        </ListItem>
                    ))
                }

            </List>

            <Stack justifyContent={'center'} direction={'row'} spacing={2} hidden={selected?.length === 0}>
                <Button variant={'contained'} onClick={handlePrint} sx={{width: 100}}>
                    Imprimer
                </Button>
            </Stack>

            <ItemView open={open} onClose={handleClose} items={selected}/>

        </Stack>
    )
}

const ItemPicker = ({onPick}) => {
    const [selected, setSelected] = useState([])

    const handlePicker = () => {
        onPick && onPick(selected)
    }

    return (
        <Grid container spacing={1}>

            <Grid item xs={11}>

                <ItemsAutoComplete
                    multiple
                    value={selected}
                    onChange={setSelected}
                />

            </Grid>

            <Grid item xs={1} justifyContent={'end'}>
                <Button variant={'contained'} onClick={handlePicker}>
                    Ajouter
                </Button>
            </Grid>

        </Grid>

    )
}

const ItemView = ({items, open, onClose}) => {
    return (
        <Dialog open={open} onClose={onClose} fullScreen>

            <Toolbar sx={{boxShadow: 5, justifyContent: 'space-between',}}>
                <Typography variant={'h6'}>
                    Aperçu du document
                </Typography>

                <IconButton onClick={onClose}>
                    <Close/>
                </IconButton>
            </Toolbar>

            <DialogContent sx={{p: 0, overflow: 'hidden'}}>

                <PDFViewer showToolbar height={'100%'} width={'100%'}>


                    <Document>
                        <Page size='A4' style={styles.page}>

                            <View style={{
                                ...styles.section,
                                flexDirection: 'column'
                            }}>
                                {
                                    items?.map(one => (
                                        <View style={{
                                            flexDirection: 'row',
                                            width: '100vw',
                                            margin: 10,
                                        }} key={one?.id}>


                                            <View style={{height: 100, width: 100, backgroundColor: '#f07171'}}>
                                                <Image
                                                    // src={one?.imageUrl}
                                                    // style={{height: 100, width: 100}}
                                                    // cache="false" crossOrigin="anonymous" allowDangerousPaths="true"
                                                    crossorigin
                                                    source={{
                                                        uri: one?.imageUrl,
                                                        headers: {
                                                            // Pragma: 'no-cache',
                                                            'Cache-Control': 'no-cache',
                                                            "Access-Control-Allow-Origin": "*"
                                                        },
                                                    }}
                                                />
                                            </View>

                                            <View style={{width: '70vw'}}>
                                                <Text style={{fontSize: 14, overflowWrap: 'break-word'}}>
                                                    {one?.name}
                                                </Text>

                                                <Text style={{fontSize: 11, overflowWrap: 'break-word'}}>
                                                    {`${one?.barCode} | ${one?.internalId} `}
                                                </Text>
                                            </View>

                                        </View>
                                    ))
                                }
                            </View>


                        </Page>
                    </Document>
                </PDFViewer>

            </DialogContent>

        </Dialog>
    )
}